import { render } from "./AgentsDashboard.vue?vue&type=template&id=2beb3e1a&scoped=true&lang=pug"
import script from "./AgentsDashboard.vue?vue&type=script&lang=js"
export * from "./AgentsDashboard.vue?vue&type=script&lang=js"

import "./AgentsDashboard.vue?vue&type=style&index=0&id=2beb3e1a&lang=scss&scoped=true"
import "./AgentsDashboard.vue?vue&type=style&index=1&id=2beb3e1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2beb3e1a"]])

export default __exports__